module.exports = __webpack_public_path__ + "img/icon-parameters.b57aa86c.svg";